import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ppt",
  "use": "icon-ppt-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-ppt\">\n  <path fill=\"#c1c2c4\" d=\"M3 8h.5a.5.5 0 0 0 0-1H3v1Zm4 0h.5a.5.5 0 0 0 0-1H7v1Z\" />\n  <path fill=\"#c1c2c4\" fill-rule=\"evenodd\" d=\"M1 1.5A1.5 1.5 0 0 1 2.5 0h8.207L14 3.293V13.5a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 13.5v-12ZM2 6h1.5a1.5 1.5 0 1 1 0 3H3v2H2V6Zm4 0h1.5a1.5 1.5 0 1 1 0 3H7v2H6V6Zm5 5h1V7h1V6h-3v1h1v4Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol